// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f9-FV","type":"styles_type__3MwZj","choices":"styles_choices__2xh4q"};